'use strict';

module.exports = {
    selectedProducts: 'selectedProducts',
    storeWide: 'storeWide',
    categoryWide: 'categoryWide',
};
